import Stack from '@mui/material/Stack'
import LogoBar from 'components/Mobile/LogoBar'
import Version from 'components/Version'
import { Outlet } from 'react-router-dom'

const MobileLayout = () => {
  return (
    <Stack sx={{ height: '100%' }}>
      <LogoBar />
      <Outlet />
      <Version />
    </Stack>
  )
}

export default MobileLayout
